import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { v_LocationDetailBus } from './v_LocationDetailBus';
import { EquipFieldData } from './EquipFieldData';
import { CommonFunctions } from '../static/common-functions';
/*
 * hidden - dispatchEquipmentXrefId
 * hidden - dispatchId
 * (checkbox)
 *Equipment Id: systemId
 * Manufacturer: manufacturerName manufacturerId
 * Model : model
 * (Additional Details - button)
 * Serial #: serialNumber
 * Type: manufacturerTypeName manufacturerTypeId
 * Barcode: barcode 
 * Notes: notes
 * Created By: createdBy
 * Date Created: creationDate;
 * (View Inventory Items Used - button)
 */
export class MiscExpenseBus extends BaseBus
{
    constructor(data: MiscExpenseBus) { 
        super(data);
        if (data) {
            if (data.costCenterName) {
                this.costCenterNameLong = data.costCenter + " - " + data.costCenterName;
            }
            this.expenseDate = CommonFunctions.getDate(data.expenseDate);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
            this.insertDt = CommonFunctions.getDate(data.insertDt);
            this.sentToPayrollDt = CommonFunctions.getDate(data.sentToPayrollDt);
        }

    }

    setId(id: any) {
        this.miscExpenseId = id;
    }
    CID(): any {
        return this.miscExpenseId;
    }
    initialize(data: MiscExpenseBus) {
        super.initialize(data);
        this.expenseDate = CommonFunctions.getDate(data.expenseDate);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: MiscExpenseBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        //this.updateDt = dateNow;
        //if (this.hasId) {
        //    //this.updateDt = dateNow;
        //    this.insertDt = data.insertDt;
        //    this.insertUserId = data.insertUserId;
        //}
        //else {
        //    this.insertDt = dateNow;
        //    this.insertUserId = data.insertUserId;
        //}

    }
    setBeforeSave() {
        //this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
          //  this.updateUserId = userId;
        }
        else {
            //this.insertDt = date;
            //this.insertUserId = userId;
            //this.updateUserId = userId;
        }
    }

    insertDt: Date;
    updateDt: Date;
    miscExpenseId: string;
    personId: string;
    expenseDate: Date;
    vendorName: string;
    materialType: string;
    amount: number;
    needsReimbursement: boolean;
    note: string;
    resourceName: string;
    sentToPayroll: boolean;
    approved: boolean;
    photoCount: number;
    costCenter: string;
    branchName: string;
    costCenterName: string;
    managerName: string;
    lineOfBusiness: string;
    incomeStatementCat: string;
    EmpNo: string;
    creditCard: string;
    cos: string;
    ovh: string;
    branchCode: string;
    attachmentDetailFullName: string;
    attachment: any;
    attachmentType: string;
    attachmentName: string;
    costCenterNameLong: string;
    sentToPayrollUserId: string;
    sentToPayrollUserName: string;
    sentToPayrollDt: Date

}
